module.exports = __webpack_public_path__ + "media/images/regions_old/Agadez-9eb7e91a2d50fac244611376890469a8.png";